import { useEffect, useState } from "react";
import config from "../config";

export const useDevModeDonateMaterialsSetup = (
  registerDevAction,
  clearDevActions,
  onToggleShowAll
) => {
  const [showAllListings, setShowAllListings] = useState(
    config.devShowAllListings
  );

  useEffect(() => {
    if (!config.isDemoMode) {
      return;
    }

    // register dev action for toggling listing visibility
    const toggleAction = {
      label: showAllListings ? "Show My Listings" : "Show All Listings",
      onClick: () => {
        const newValue = !showAllListings;
        setShowAllListings(newValue);
        onToggleShowAll(newValue);
      },
    };

    registerDevAction(toggleAction);

    return () => {
      clearDevActions();
    };
  }, [registerDevAction, clearDevActions, showAllListings, onToggleShowAll]);

  return { showAllListings };
};
